<template>
  <v-container fluid>
    <div v-if="sleuthConfig">
      <div class="text-h5 text-left">Result Filters</div>
      <v-divider></v-divider>
      <div class="text-subtitle-2 mt-2 mb-2 text-left grey--text text--darken-1">
        Customize how Repost Sleuth filters search results
      </div>
      <v-row>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.same_sub_only" label="Same Sub" hint="Only search this subreddit" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.filter_crossposts" label="Filter Crossposts" hint="Exclude crossposts in search" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.meme_filter" label="Meme Filter" hint="Applies logic for memes" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-slider
              v-model="sleuthConfig.target_image_meme_match"
              thumb-label
              label="Meme Match"
              min="0"
              max="100"
              hint="How close a match should be"
              persistent-hint
              class="mt-4 pr-3"
              :disabled="!sleuthConfig.meme_filter"
          ></v-slider>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.filter_same_author" label="Ignore From Author" hint="Include matches from same author" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.filter_removed_matches" label="Filter removed matches" hint="Drop removed posts from results" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-switch v-model="sleuthConfig.check_title_similarity" label="Check Title" hint="Also check how close title matches" persistent-hint></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-slider
              v-model="sleuthConfig.target_title_match"
              thumb-label
              label="Title Match"
              min="0"
              max="100"
              hint="How close a match should be"
              persistent-hint
              class="mt-3 pr-3"
              :disabled="!sleuthConfig.check_title_similarity"
          ></v-slider>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-text-field v-model="sleuthConfig.target_days_old" outlined type="number" :label="`Target Days Old`" hint="0 is unlimited"></v-text-field>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "SearchFilterSettings",
  props: {
    sleuthConfig: Object
  }
}
</script>

<style scoped>

</style>
